import CatalogGrid from '@/components/CatalogCard/CatalogGrid';
import CompleteAccountBanner from '@/components/CompleteAccountBanner/CompleteAccountBanner';
import PageTitle from '@/components/PageTitle/PageTitle';
import { useAppSelector } from '@/redux/hooks';
import { getFeaturedCatalogs } from '@/redux/modules/featuredCatalogs';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

const FeaturedCatalogsPage = () => {
    const catalogIds = useAppSelector(getFeaturedCatalogs);
    const formatMessage = useAppFormatMessage();

    return (
        <div className="mx-auto w-full max-w-[1240px] px-sm pb-lg">
            <CompleteAccountBanner />
            <PageTitle title={formatMessage(['featured_auctions'])} />
            <CatalogGrid
                catalogIds={catalogIds}
                className="mx-xs"
            />
        </div>
    );
};

export default FeaturedCatalogsPage;
